import { Breadcrumb, Button, Pagination, Popconfirm, Spin, Table } from "antd";
import Title from "antd/lib/typography/Title";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  actHideLoading,
  actShowLoading,
} from "../../../../actions/actionLoading";
import {
  deleteYeuCauThanhToan,
  fetchYeuCauThanhToan,
} from "../../../../actions/actionYeuCauThanhToan";
import {
  addFormData,
  convertDateTime,
  FetchURL,
  openNotificationWithIcon,
} from "../../../../util/help";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import axios from "../../../../util/api";
import SearchComponent from "../../../../Component/SearchComponent";

function YeuCauThanhToan() {
  const [state, setState] = useState({ total_page: 1 });
  const [search, setSearch] = useState({ type: "", keyword: "" });

  const isLoading = useSelector((state) => state.isLoading);
  const yeucau = useSelector((state) => state.yeucauthanhtoan);

  const dispatch = useDispatch();
  const showLoading = () => dispatch(actShowLoading());
  const hideLoading = () => dispatch(actHideLoading());
  const Fetch = (data) => dispatch(fetchYeuCauThanhToan(data));
  const DeleteYeuCauThanhToan = (JOB_NO) =>
    dispatch(deleteYeuCauThanhToan(JOB_NO));

  useEffect(() => {
    onChangePage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search.keyword]);

  const onChangePage = (page) => {
    var newPage = 1;
    var url = "";
    if (page) {
      newPage = page;
    }
    if (search.keyword) {
      url = `payment/debit-note/search/type=${search.type}&value=${search.keyword}&page=${newPage}`;
    } else {
      url = `payment/debit-note/page=${newPage}`;
    }
    showLoading();
    fetch(FetchURL + url)
      .then((res) => res.json())
      .then((data) => {
        if (data.success === true) {
          Fetch(data.data);
          setState({ total_page: data.total_page });
          hideLoading();
        }
      })
      .catch((err) => console.log(err));
  };

  const Delete = (JOB_NO) => {
    var params = {
      JOB_NO: JOB_NO,
    };
    showLoading();
    axios
      .post("payment/debit-note/remove", addFormData(params))
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            DeleteYeuCauThanhToan(JOB_NO);
            hideLoading();
            openNotificationWithIcon(
              "success",
              `Bạn đã Delete thành công ${JOB_NO}`
            );
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const columns = [
    {
      title: "Job No",
      dataIndex: "JOB_NO",
      key: "JOB_NO",
    },
    {
      title: "CUST",
      dataIndex: "CUST_NO",
      key: "CUST_NO",
    },
    {
      title: "Debit Date",
      dataIndex: "DEBIT_DATE",
      key: "DEBIT_DATE",
      render: (text) => convertDateTime(text),
    },
    {
      title: "Input",
      dataIndex: "INPUT_USER",
      key: "INPUT_USER",
    },
    {
      title: "Edit",
      dataIndex: "MODIFY_USER",
      key: "MODIFY_USER",
    },
    {
      render: (text, record) => (
        <>
          <Link to={`/Dasboard/yeucauthanhtoan/edit/${record.JOB_NO}`}>
            <Button
              type="primary"
              style={{
                backgroundColor: "#faad14",
                borderColor: "#faad14",
                marginRight: 20,
              }}
              icon={<EditOutlined />}
            >
              <span style={{ marginLeft: 8, color: "white" }}>Edit</span>
            </Button>
          </Link>
          {(localStorage.getItem("USER_NO") === "PC                  ") |
          (localStorage.getItem("USER_NO") === "QUYNH               ") |
          (localStorage.getItem("USER_NO") === "JENNY               ") ? (
            <Popconfirm
              title="Bạn có chắn chắn Delete?"
              onConfirm={() => Delete(record.JOB_NO)}
            >
              <Button type="primary" danger icon={<DeleteOutlined />}>
                Delete
              </Button>
            </Popconfirm>
          ) : null}
        </>
      ),
    },
  ];

  function onSearch(values) {
    setSearch({
      type: values.type,
      keyword: values.keyword,
    });
  }

  return (
    <Spin size="large" spinning={isLoading}>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>RECEIPTS AND PAYMENT</Breadcrumb.Item>
        <Breadcrumb.Item>Yêu Cầu Thanh Toán</Breadcrumb.Item>
      </Breadcrumb>
      <div
        className="site-layout-background"
        style={{ padding: 24, minHeight: 360 }}
      >
        <div style={{ textAlign: "center" }}>
          <Title style={{ color: "#1890ff" }}>Yêu Cầu Thanh Toán</Title>
        </div>
        <SearchComponent onSearch={onSearch} />
        <Button type="primary" style={{ marginBottom: 20 }}>
          <Link to="/Dasboard/yeucauthanhtoan/create">Create</Link>
        </Button>
        <Table
          dataSource={yeucau}
          columns={columns}
          rowKey={columns[0].key.toString()}
          pagination={false}
          size="small"
        />
        <Pagination
          total={state.total_page}
          defaultCurrent={1}
          onChange={onChangePage}
          style={{ marginTop: 20 }}
        />
      </div>
    </Spin>
  );
}

export default YeuCauThanhToan;
